module.exports = __webpack_public_path__ + "media/theme/top_accordion_PC_1 open-50827133.png";